import { Box, Dialog, Typography } from "@mui/material"
import type { FC } from "react"

import CircularLoadingIndicator from "@/components/common/LoadingIndicators/CircularLoadingIndicator"

export const BulkUpdateApplyingDialog: FC = () => (
  <Dialog open maxWidth='xs' fullWidth data-testid='pricing.bulk-update-applying-dialog'>
    <Box className='flex flex-col items-center gap-4 p-8'>
      <CircularLoadingIndicator />
      <Typography variant='body1' className='text-gray-800'>
        Applying bulk update...
      </Typography>
    </Box>
  </Dialog>
)
